import { render, staticRenderFns } from "./VantFieldArea.vue?vue&type=template&id=20b4ad7b&scoped=true&"
import script from "./VantFieldArea.vue?vue&type=script&lang=js&"
export * from "./VantFieldArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b4ad7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b4ad7b')) {
      api.createRecord('20b4ad7b', component.options)
    } else {
      api.reload('20b4ad7b', component.options)
    }
    module.hot.accept("./VantFieldArea.vue?vue&type=template&id=20b4ad7b&scoped=true&", function () {
      api.rerender('20b4ad7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Address/VantFieldArea.vue"
export default component.exports